/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { GetApiFeedbacksCountQueryResponse, GetApiFeedbacksCountQueryParams, GetApiFeedbacksCount400, GetApiFeedbacksCount401, GetApiFeedbacksCount403, GetApiFeedbacksCount404, GetApiFeedbacksCount500 } from "../../types/GetApiFeedbacksCount.ts";
import { getApiFeedbacksCountQueryResponseSchema } from "../../zod/FeedbackSchemas/getApiFeedbacksCountSchema.ts";

function getGetApiFeedbacksCountUrl() {
  const res = { method: 'GET', url: `/api/feedbacks/count` as const }  
  return res
}

/**
 * @summary Получить количество незакрытых обращений
 * {@link /api/feedbacks/count}
 */
export async function getApiFeedbacksCount({ params }: { params?: GetApiFeedbacksCountQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetApiFeedbacksCountQueryResponse, ResponseErrorConfig<GetApiFeedbacksCount400 | GetApiFeedbacksCount401 | GetApiFeedbacksCount403 | GetApiFeedbacksCount404 | GetApiFeedbacksCount500>, unknown>({ method : "GET", url : getGetApiFeedbacksCountUrl().url.toString(), params, ... requestConfig })  
  return getApiFeedbacksCountQueryResponseSchema.parse(res.data)
}